var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BModal',{attrs:{"active":""},on:{"close":_vm.handleClose}},[_c('div',{staticClass:"container container-extra-extra-small"},[_c('Box',{attrs:{"flat":"","black":""}},[_c('Title',[_vm._v("Settings")]),_c('Field',[_c('Label',[_vm._v("Position")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }